import { useCallback, useState } from "react"
import styled from "styled-components"
import {
  Button,
  Form,
  FormField,
  Input,
  Label,
  LargeButton,
} from "~/components"
import { useTranslate } from "~/ur-react-hooks"
import { trpc } from "~/utils/trpc"
import { validateEmail } from "~/utils/validation"

const Layout = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin-top: 2rem;
`

const Card = styled.div`
  background: white;
  box-shadow: ${(props) => props.theme.shadow.elevation3};

  padding: 2rem 1.5rem;

  border-radius: 8px;

  width: 378px;
`

const Title = styled.h2`
  margin-bottom: 2rem;
  width: 450px;
  text-align: center;
`

const Subtitle = styled.p`
  width: 400px;
  margin-bottom: 2rem;
  margin-top: 0;
`

const _LogoutWrapper = styled.div`
  margin-top: 1rem;
`

export type FeideMissingEmailProps = {}

const FeideMissingEmail: React.FC<FeideMissingEmailProps> = ({}) => {
  const [email, setEmail] = useState("")
  const [_error, setError] = useState<null | string>(null)

  const translations = useTranslate({
    title: "feide-missing-email.title",
    subtitle: "feide-missing-email.subtitle",
    submit: "feide-missing-email.submit",
    email: "common.email",
  })

  const trpcContext = trpc.useContext()

  const { mutate: addMissingEmailAfterFeideLogin } =
    trpc.authentication.addMissingEmailAfterFeideLogin.useMutation({
      onSuccess() {
        trpcContext.users.me.invalidate()
      },
    })

  const handleSubmit = useCallback(() => {
    const error = validateEmail("E-posten er ikke gyldig")(email)

    if (error) {
      setError(error)
      return
    }

    addMissingEmailAfterFeideLogin({ email })
  }, [email, addMissingEmailAfterFeideLogin])

  return (
    <Layout>
      <Title>{translations.title}</Title>
      <Subtitle>{translations.subtitle}</Subtitle>
      <Card>
        <Form preventDefault onSubmit={handleSubmit}>
          <FormField>
            <Label>{translations.email}</Label>
            <Input
              width="100%"
              value={email}
              onChange={(value) => setEmail(value)}
            />
          </FormField>
          <Button width="100%">{translations.submit}</Button>
        </Form>
      </Card>
    </Layout>
  )
}

export default FeideMissingEmail
